import { ApiService } from "./ApiService";

export class GameService extends ApiService {
  getGameDetails(id) {
    return this.apiRequestGet(`games/${id}/meta`);
  }
}
